export const primaryList = [
  {
    name: "一年级",
    id: 1,
  },
  {
    name: "二年级",
    id: 2,
  },
  {
    name: "三年级",
    id: 3,
  },
  {
    name: "四年级",
    id: 4,
  },
  {
    name: "五年级",
    id: 5,
  },
  {
    name: "六年级",
    id: 6,
  },
  {
    name: "预初",
    id: 7,
  },
];
export const juniorList = [
  {
    name: "初一",
    id: 8,
  },
  {
    name: "初二",
    id: 9,
  },
  {
    name: "初三",
    id: 10,
  },
];
export const highList = [
  {
    name: "高一",
    id: 11,
  },
  {
    name: "高二",
    id: 12,
  },
  {
    name: "高三",
    id: 13,
  },
];
export const subjectaObj = {
  primary: [
    {
      name: "语文",
      id: 1,
    },
    {
      name: "数学",
      id: 2,
    },
    {
      name: "英语",
      id: 3,
    },
  ],
  juniorOne: [
    {
      name: "语文",
      id: 1,
    },
    {
      name: "数学",
      id: 2,
    },
    {
      name: "英语",
      id: 3,
    },
    {
      name: "科学",
      id: 8,
    },
    {
      name: "生物",
      id: 7,
    },
    {
      name: "地理",
      id: 9,
    },
    {
      name: "历史",
      id: 10,
    },
    {
      name: "政治",
      id: 11,
    },
  ],
  juniorTwo: [
    {
      name: "语文",
      id: 1,
    },
    {
      name: "数学",
      id: 2,
    },
    {
      name: "英语",
      id: 3,
    },

    {
      name: "物理",
      id: 4,
    },
    {
      name: "生物",
      id: 7,
    },
    {
      name: "地理",
      id: 9,
    },
    {
      name: "历史",
      id: 10,
    },
    {
      name: "政治",
      id: 11,
    },
  ],
  juniorThree: [
    {
      name: "语文",
      id: 1,
    },
    {
      name: "数学",
      id: 2,
    },
    {
      name: "英语",
      id: 3,
    },
    {
      name: "物理",
      id: 4,
    },
    {
      name: "化学",
      id: 5,
    },
  ],
  high: [
    {
      name: "语文",
      id: 1,
    },
    {
      name: "数学",
      id: 2,
    },
    {
      name: "英语",
      id: 3,
    },
    {
      name: "物理",
      id: 4,
    },
    {
      name: "化学",
      id: 5,
    },
    {
      name: "生物",
      id: 7,
    },
    {
      name: "地理",
      id: 9,
    },
    {
      name: "历史",
      id: 10,
    },
    {
      name: "政治",
      id: 11,
    },
  ],
};
